import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IPrevMonthBudgetTable, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faCommentDots, faEdit, faExclamationTriangle, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants'
import { PRIVILEGE } from '../../types/privileges';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import { getColorBudget } from '../../services/misc';

const PrevMonthBudgetTable = ({ 
  linesData,
  month,
  budgetType,
  auth
 }: IPrevMonthBudgetTable) => {

  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "month",
        className: "tableLeftHeader tableStickyColumn text-left",
        disableSortBy: true,
        Cell: ({ value, row: {original} }) => value
      },
      ...([
          {title: "Objectifs Ventes", accessor1: "goalV", accessor2: "sPrixNet"},
          {title: "Objectifs Encaissements Ventes", accessor1: "goalE", accessor2: "sEncaissements"},
          {title: "Objectifs Recouvrement", accessor1: "goalR", accessor2: "sRecouvrement"},
          {title: "Objectifs Livraison", accessor1: "goalL", accessor2: "sLivraison"}
        ].map(e => ({
        Header: e.title,
        accessor: row => row[e.accessor1] ? Number(row[e.accessor1] || 0) - Number(row[e.accessor2] || 0) : 0,
        disableFilters: true,
        className: "text-center",
        Cell: ({ row: {original} }) => <div>
          <div><b>Réalisé:</b></div>
          <b>{`${Number(original[e.accessor2] || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH`}</b>
          &nbsp;sur&nbsp;
          {`${Number(original[e.accessor1] || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH`}
          &nbsp;
          <span className="encPercent" style={{color: getColorBudget((original[e.accessor1] ? Math.ceil((Number(original[e.accessor2] || 0) * 100) / Number(original[e.accessor1] || 0)) : 0))}}>
            ({`${original[e.accessor1] ? Math.ceil((Number(original[e.accessor2] || 0) * 100) / Number(original[e.accessor1] || 0)) : 0} %`})
          </span>
          <div><b>Écart:</b>&nbsp;{`${(Number(original[e.accessor1] || 0) - Number(original[e.accessor2] || 0)).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH`}</div>
        </div>
      }))),
    ],
    [month, budgetType]
  )

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} enableCheckBox={false} isEditable={false} bgColor="black" hideFiltersByDefault smallerCols centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(PrevMonthBudgetTable);
